import loglevel from 'loglevel';
import request from './cache/requestCache';
import proxy from './requestProxy';
import fallback from './cache/fallbackCache';
import toAbsoluteURL from 'lib/url-adapter/toAbsoluteURL';
import Provider from 'lib/auth/Provider';
import { AdobePass } from 'enums';
import { queryString } from 'lib/format';

const { Env: AdobePassEnv } = AdobePass;

const log = loglevel.getLogger('ClientAPI');

const ONE_HOUR = 3600;

const CONFIGURATION = {
    baseUrl: '//api-app.espn.com',
    baseInternalUrl: '//sports-bc.prod.espninfra.starwave.com',
    endPoint: '/v1/watch/clients/',
    apiKey: '',
    intlProviderServiceUrl: 'https://affiliate.api.espn.com/affiliateApi/affiliates'
};

const QA_CONFIGURATION = {
    baseUrl: '//broadband.espnqa.com/espn360/apis',
    baseInternalUrl: '//sports-bc.qa.espninfra.starwave.com/espn360/apis',
    endPoint: '/v1/watch/clients/',
    apiKey: '',
    intlProviderServiceUrl: 'https://affiliate.api.qa.espn.com/affiliateApi/affiliates'
}

const INTL_QUERY = {
    includeProperties: true,
    rows: 1000,
    apikey: 'iay88gnrz4un1jiaclo88df33'
};

export const FULL_PREAUTH_PROVIDERS = [
    'Comcast_SSO',
    'ATT',
    'Charter_Direct',
    'TWC',
    'Brighthouse',
    'Cablevision',
    'Verizon',
    'Bend',
    'WOW',
    'Suddenlink',
    'Mediacom',
    'Dish',
    'Grande',
    'HTC',
    'RCN'
];

function getServiceUrl({ passenv, platform = 'web', partner = 'watchespn' } = {}) {
    let config = CONFIGURATION;
    if (passenv === AdobePassEnv.STAGING) {
        config = QA_CONFIGURATION;
    }
    return `${toAbsoluteURL(config.baseUrl)}${config.endPoint}${partner}-${platform}`;
}

function getProviderServiceUrl ({ country, passenv, platform }) {
    let config = CONFIGURATION;
    if (passenv === AdobePassEnv.STAGING) {
        config = QA_CONFIGURATION;
    }
    if (country === 'US') {
        return `${getServiceUrl({ passenv, platform })}/providers?country=${country}`;
    }

    return `${config.intlProviderServiceUrl}${queryString({ ...INTL_QUERY, country })}`;
}

export function getClient({ passenv = AdobePassEnv.PROD, platform = 'web' } = {}) {
    const url = `${getServiceUrl({ passenv, platform })}?enable=providers,channels`;

    log.debug(`getClient: ${url}`);

    return request(url)
        .expiration(ONE_HOUR)
        .use(proxy)
        .then(({ body }) => {
            const client = body.clients[0];
            const result = {
                channels: client.channels,
                providers: client.providers
            };

            fallback.set(url, result);
            return result;
        })
        .catch((err) => {
            log.error('getClient:', err.originalError);
            return fallback.get(url);
        });
}

export function getProviders({ country, passenv = AdobePassEnv.PROD, partner, platform, version } = {}) {
    const url = getProviderServiceUrl({ country, passenv, platform });
    log.debug(`getProviders: ${url}`);

    return request.get(url)
        .expiration(ONE_HOUR)
        .use(proxy)
        .then(({ body }) => {
            const { clients } = body;
            if (clients) {
                const client = clients[0];
                const providers = client.providers.map((provider) => (Provider.createProviderDomestic(provider, partner, platform, version)));
                fallback.set(url, providers);
                return providers;
            }

            const { rows } = body;
            if (rows) {
                const intlProviders = rows.map(({ data }) => (Provider.createProviderIntl(data, country)));
                fallback.set(url, intlProviders);
                return intlProviders;
            }
        })
        .catch((err) => {
            log.error('getProviders:', err.originalError);
            return fallback.get(url);
        });
}

export function getProvider({ abbreviation, country = 'US', passenv = AdobePassEnv.PROD, partner = 'watchespn', platform = 'flash' } = {}) {
    if (country === 'US') {
        const url = `${getServiceUrl({ passenv, platform })}/providers/${abbreviation}`;

        log.debug(`getProviders: ${url}`);

        return request.get(url)
            .expiration(ONE_HOUR)
            .use(proxy)
            .then(({ body }) => {
                const { clients } = body;
                if (clients) {
                    const client = clients[0];
                    const provider = Provider.createProviderDomestic(client.providers[0], partner, platform);
                    fallback.set(url, provider);
                    return provider;
                }
            })
            .catch((err) => {
                log.error('getProvider:', err.originalError);
                return fallback.get(url);
            });
    }
    return Promise.resolve();
}



// WEBPACK FOOTER //
// ./app/lib/api/ClientAPI.js